import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useCanRenderSmartBannerPage from '../hooks/useCanRenderSmartBanner';
import { isMobileSelector } from '../selector/device';
import { profileSelector } from '../selector/user';
import setWrappedComponent from '../utils/react/setWrappedComponent';
import imageSrc from '../../common/image';
import sendLegacyEvent from '../utils/tracking/sendLegacyEvent';
import { ga4DlAPP } from '../utils/ga4';


export default function renderSmartBanner(WrappedComponent) {
  function RenderSmartBanner(props) {
    const isMobile = useSelector(isMobileSelector);
    const profile = useSelector(profileSelector);
    const canRender = useCanRenderSmartBannerPage();
    const [isSmartBannerShowed, toggleSmartBanner] = useState(true);

    if (!isMobile || !canRender) {
      return <WrappedComponent {...props} />;
    }

    const handleClickOpenBtn = () => {
      sendLegacyEvent({
        api: "user_preference",
        event10: "DL_APP",
        isMobile,
        profile,
      });
      ga4DlAPP(profile);
      window.dataLayer.push({event: 'FBQ_DL_APP'});
      window.location = 'https://bnc.lt/MuAd/It9UEWUaihb';
    };

    return (
      <>
        {isSmartBannerShowed && (
          <div 
            className="z-30 relative w-full sticky top-0 bg-brand-grey-100 font-500 h-full flex items-center flex-nowrap pr-4 py-3"
            style={{height: 'var(--smartbanner-height)'}}
          >
            <button
              type="button"
              className="material-icons w-6 h-6 text-16 text-brand-grey-800 focus:outline-none"
              data-icon="close"
              onClick={() => toggleSmartBanner(false)}
            />
            <img 
              src={`${imageSrc}/svg/download_smartbanner_launcher.svg`}
              className="w-12 h-12 mx-2"
              alt="Download LINE TV APP Launcher Icon"
            />
            <div className="flex flex-col items-start">
              <img 
                src={`${imageSrc}/svg/download_smartbanner_logo.svg`}
                className="h-4"
                alt="Download LINE TV APP Logo" 
              />
              <div className="text-12 text-brand-grey-600 mt-1">免費用 LINE TV APP</div>
            </div>
            <button className="flex-none Btn Btn--green Btn--sm w-20 ml-auto" onClick={handleClickOpenBtn}>
              開啟
            </button>
          </div>
        )}
        <WrappedComponent isSmartBannerShowed={isSmartBannerShowed} {...props} />
      </>
    );
  }

  setWrappedComponent(RenderSmartBanner, WrappedComponent);


  return RenderSmartBanner;
}
